import { getAmplitudeInstance } from '../amplitudeHelpers';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logUpsellPlanCompareTappedParams = {
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User taps on the choose your plan compare button.
 * @param params - Attributes to log with the amplitude event
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellPlanCompareTapped = ({ purchase_screen_type_plan, trigger }: logUpsellPlanCompareTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('upsell plan compare tapped', { 'purchase screen type plan': purchase_screen_type_plan, trigger }, callback);
};

export default logUpsellPlanCompareTapped;
